export default __webpack_public_path__ + "static/media/kalahastiTemple4.428df383.png";